import { useNavigate } from 'react-router-dom';

import { ModalProps } from '@mui/material';

import CFSCareLinkDetail from '@/pages/CFS/CFSCareLink/CFSCareLinkDetail';

import { SideModal } from '../SideModal';

interface CareLinkModalProps extends Omit<ModalProps, 'children' | 'onClose'> {
  onClose?: () => void;
  backRoute?: string;
}

export const CareLinkModal = ({
  onClose,
  backRoute,
  ...rest
}: CareLinkModalProps) => {
  const navigate = useNavigate();

  if (!onClose) {
    onClose = () => {
      navigate(backRoute ?? '/cfs-active');
    };
  }

  return (
    <SideModal {...rest} onClose={onClose} width="50%" closingType="hide">
      <CFSCareLinkDetail />
    </SideModal>
  );
};
